import type { HistorySearchItem, SuggestResponse } from "../types/suggestion";

/*                                                         */
/*         */
import templateString from "../../public/templates/emptyStateLayer.mustache";
import { headlineTemplate, keywordsTemplate } from "./emptyState.templates";

import { EmptyStateTime, SuggestRenderTime } from "../times";
import { CookieBanner } from "../helper";
import { SELECTOR } from "../types/element/constants";
import { Queue } from "../suggest/PromiseQueue";

const Mustache = window.Mustache;

export class EmptyStateSuggest {
  private suggestLayer: HTMLDivElement;
  private searchField: HTMLInputElement;
  private searchForm: HTMLFormElement;

  constructor() {
    this.suggestLayer = document.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchForm = document.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
  }

  init() {
    this.suggestLayer = document.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchForm = document.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
  }

  show() {
    EmptyStateTime.reset();
    return Queue.enqueue(() =>
      this.retrieveEmptyState()
        .then(this.renderSuggest.bind(this))
        .then(() => {
          window.o_squirrel.searchSuggest.setSuggest(-1);
        })
        .then(window.o_squirrel.searchSuggest.showLayer)
        .then(window.o_squirrel.searchSuggest.scrollToSearchField)
        .catch(window.o_squirrel.searchSuggest.handleError),
    );
  }

  private renderKeywordTemplate(suggestions: SuggestResponse): string {
    const keywords =
      window.o_squirrel.submitHistory.retrieveViewedSearch().length > 0
        ? suggestions.keywords.slice(0, 5)
        : suggestions.keywords;
    return Mustache.render(keywordsTemplate, {
      original: suggestions.original,
      keywords,
      suggestPos: suggestions.suggestPos,
    });
  }

  renderSuggest(results: SuggestResponse | Error | string) {
    const suggestions: SuggestResponse = results as SuggestResponse;
    const historyTemplate: string = this.renderHistoryTemplate();

    const renderedTemplate: string = Mustache.render(
      templateString,
      {},
      {
        headlineTemplate,
        historyTemplate,
        keywordTemplate: this.renderKeywordTemplate(suggestions),
      },
    );
    SuggestRenderTime.measure();
    this.suggestLayer.innerHTML = renderedTemplate;
  }

  retrieveEmptyState(): Promise<SuggestResponse | Error | string> {
    return window.o_squirrel.searchSuggest
      .fetchSuggestions("", 0, {})
      .then(window.o_squirrel.searchSuggest.extractSuggestions)
      .then(window.o_squirrel.searchSuggest.updateSearchFieldTarget);
  }

  private renderHistoryTemplate() {
    if (CookieBanner.isEnabled() && !window.o_squirrel.submitHistory.isEmpty()) {
      const response: HistorySearchItem[] = window.o_squirrel.submitHistory.retrieveViewedSearch().slice().reverse();
      return window.o_squirrel.searchHistory.renderHistory(response);
    } else {
      return "";
    }
  }
}

const instance = new EmptyStateSuggest();
export const emptyStateSuggest = {
  init: instance.init.bind(instance),
  show: instance.show.bind(instance),
};
